function getAllSamples () {
  if (!this.samples) return
  const samples = Object.values(this.samples).filter(sample => !sample.delete)
  return samples
}

export default getAllSamples